import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import imageUpload from "components/imageUpload.vue";
export default {
  data: function data() {
    return {
      list: [],
      SiteList: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,
      dialogVisibleAudit: false,

      /* -----------添加/修改弹框参数------------ */
      title: "",
      content: "",
      avatorUrl: "",
      newsType: 1,
      orderNumber: 0,
      pulishTime: "",

      /* --------------------------------------- */
      id: "",
      siteId: "",
      siteName: "",
      value: "",
      teacherId: '',
      materialInfo: [],
      imgsList: [],
      indexCount: 0,
      imgUrl: "",
      dialogVisiblePreviewResources: false,
      IsAuthentication: 1,
      unitOpinion: '',
      auditOpinion: '',
      TrainApplyId: ""
    };
  },
  // components: {
  //   imageUpload
  // },
  created: function created() {
    this.getSessionStorage();
    this.school = this.$store.state.auth.userName;
    this.getTrainApplyList();
  },
  methods: {
    getTrainApplyList: function getTrainApplyList() {
      var _this = this;

      var that = this;
      this.$http.post("/api/XOrg/AssociationTeacher/getTrainApplyList", {
        page: this.pageIndex,
        pageSize: this.pageSize,
        name: that.title,
        type: 1
      }).then(function (rst) {
        if (rst.code == 1) {
          _this.list = rst.list;
          _this.total = rst.pagination.totalCount;
          _this.pageSize = rst.pagination.pageSize;
          _this.pageIndex = rst.pagination.pageIndex; // 参数存储本地缓存

          sessionStorage.setItem("wlx_TeacherAudit_pageIndex", that.pageIndex);
          sessionStorage.setItem("wlx_TeacherAudit_pageSize", that.pageSize);
          sessionStorage.setItem("wlx_TeacherAudit_title", that.title);
        } else {
          _this.$message.warning(rst.msg);
        }
      });
    },
    // 获取网页缓存信息
    getSessionStorage: function getSessionStorage() {
      // 获取网页缓存信息
      var pageIndex = sessionStorage.getItem("wlx_TeacherAudit_pageIndex");
      var pageSize = sessionStorage.getItem("wlx_TeacherAudit_pageSize");
      var title = sessionStorage.getItem("wlx_TeacherAudit_title");

      if (pageIndex != null && pageIndex != undefined) {
        this.pageIndex = pageIndex;
      }

      if (pageSize != null && pageSize != undefined) {
        this.pageSize = pageSize;
      }

      if (title != null && title != undefined && title != "null") {
        this.title = title;
      }
    },
    cancel: function cancel() {
      this.dialogVisibleAudit = false, this.unitOpinion = '';
      this.auditOpinion = '';
      this.IsAuthentication = '';
    },
    audit: function audit(row) {
      this.teacherId = row.userId;
      this.TrainApplyId = row.id;
      this.unitOpinion = row.unitOpinion;
      this.auditOpinion = row.auditOpinion;
      this.IsAuthentication = row.IsPost == 0 ? '' : row.IsPost;
      this.dialogVisibleAudit = true;
    },
    //审核
    shenhe: function shenhe() {
      var that = this;
      this.$http.post('/api/XOrg/AssociationTeacher/auditTeaActivity', {
        teacherId: that.teacherId,
        type: that.IsAuthentication,
        unitOpinion: that.unitOpinion,
        auditOpinion: that.auditOpinion,
        id: that.TrainApplyId
      }).then(function (rst) {
        if (rst.code == 1) {
          that.$message.success(rst.msg);
          that.dialogVisibleAudit = false;
          that.getTrainApplyList();
        } else if (rst.code == -2) {
          that.$message.warning(rst.msg);
          that.dialogVisibleAudit = false;
          that.getTrainApplyList();
        } else {
          that.dialogVisibleAudit = false;
          that.$message.warning(rst.msg);
        }
      });
    },
    // 查看
    goView: function goView(id) {
      this.$router.push({
        name: 'applyTableDetail',
        params: {
          userId: id,
          userType: '1'
        }
      });
    },
    onPageChangeHandler: function onPageChangeHandler(page) {
      this.pageIndex = page;
      this.getTrainApplyList(page);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.getTrainApplyList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.ids = [];
      val.forEach(function (element) {
        _this2.ids.push(element.Id);
      });
    },
    viewSchoolNews: function viewSchoolNews(row) {
      this.title = row.title;
      this.content = row.content;
      this.viewNoticeVisible = true;
    },
    search: function search() {
      this.pageIndex = 1;
      this.getTrainApplyList();
    }
  }
};